import { render, staticRenderFns } from "./TodaysCardDeliveryDeposits.vue?vue&type=template&id=399a2e7c&scoped=true&"
import script from "./TodaysCardDeliveryDeposits.vue?vue&type=script&lang=ts&"
export * from "./TodaysCardDeliveryDeposits.vue?vue&type=script&lang=ts&"
import style0 from "./TodaysCardDeliveryDeposits.vue?vue&type=style&index=0&id=399a2e7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399a2e7c",
  null
  
)

export default component.exports